import { SeriesTypeEnum } from '@/src/features/analytics/enums/seriesType.enum'
import { t } from 'i18next'

type Translate = (key: string) => string

const SERIES_TYPE_TRANSLATION_KEYS: Record<SeriesTypeEnum, string> = {
  [SeriesTypeEnum.electricity]: 'energy_types_electricity',
  [SeriesTypeEnum.gas]: 'energy_types_gas',
  [SeriesTypeEnum.water]: 'energy_types_water',
  [SeriesTypeEnum.pressurizedAir]: 'energy_types_pressurized_air',
  [SeriesTypeEnum.heating]: 'energy_types_heating',
  [SeriesTypeEnum.fuels]: 'energy_types_fuels',
  [SeriesTypeEnum.fluidGas]: 'energy_types_fluid_gas',
  [SeriesTypeEnum.custom]: 'energy_types_custom',
  [SeriesTypeEnum.special]: 'energy_types_special',
  [SeriesTypeEnum.virtualMeter]: 'energy_types_virtual_meter',
  [SeriesTypeEnum.temperature]: 'energy_types_temperature',
}

export const getSeriesTypeLabel = (seriesType: SeriesTypeEnum | string, translate: Translate = t): string => {
  const translationKey = SERIES_TYPE_TRANSLATION_KEYS[seriesType as SeriesTypeEnum]
  return translationKey ? translate(translationKey) : seriesType
}
